import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SvgLoaderModule } from '@merchant-portal/app/components/icon/svg-loader/svg-loader/svg-loader.module';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-waiting-card-setup-dialog',
  standalone: true,
  imports: [CommonModule, SvgLoaderModule],
  templateUrl: './waiting-card-setup-dialog.component.html',
  styleUrl: './waiting-card-setup-dialog.component.scss',
})
export class WaitingCardSetupDialogComponent {
  private config = inject(DynamicDialogConfig);
  isCheckingStatus = false;

  constructor(public ref: DynamicDialogRef) {}

  checkStatus() {
    this.isCheckingStatus = true;
  }

  closeDialog() {
    this.ref.close('close');
  }
}
